import { useState, useEffect, useRef } from 'react'
import { useAccessibleRoutes } from './useAccessibleRoutes'

export const defaultMenuOptions = [
  { title: 'Inbound Ticket', action: '/app/purchases/ticket-library/new', module: 'purchases' },
  { title: 'Outbound Ticket', action: '/app/sales/outbound-tickets/new', module: 'sales' },
  { title: 'Bill', action: '/app/purchases/bills/new', module: 'purchases' },
  { title: 'Invoice', action: '/app/sales/invoices/new', module: 'sales' },
  { title: 'Dispatch Ticket', action: '/app/load-board/ticket-history/new', module: 'load-board' },
  { title: 'Sales Order', action: '/app/contracts/sales-orders/new', module: 'contracts' },
  { title: 'Purchase Order', action: '/app/contracts/purchase-orders/new', module: 'contracts' },
]

export const useHotkeyNavigation = () => {
  const [hotkeyModalOpen, setHotkeyModalOpen] = useState(false)
  const accessibleMenuOptions = useAccessibleRoutes(defaultMenuOptions)
  const keyDownTimeRef = useRef<number>(0)

  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      const activeElement = document.activeElement as HTMLElement
      const isInput =
        activeElement.tagName === 'INPUT' ||
        activeElement.tagName === 'TEXTAREA' ||
        activeElement.contentEditable === 'true'

      if ((event.key === 'g' || event.key === 'G') && !hotkeyModalOpen && !isInput) {
        setHotkeyModalOpen(true)
        keyDownTimeRef.current = Date.now()
      }
    }

    const handleKeyUp = (event: KeyboardEvent) => {
      if (event.key === 'g' || event.key === 'G') {
        const keyDownDuration = Date.now() - keyDownTimeRef.current

        if (keyDownDuration > 750) {
          setHotkeyModalOpen(false)
        }
      }
    }

    window.addEventListener('keydown', handleKeyDown)
    window.addEventListener('keyup', handleKeyUp)

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      window.removeEventListener('keyup', handleKeyUp)
    }
  }, [hotkeyModalOpen])

  return {
    hotkeyModalOpen,
    setHotkeyModalOpen,
    accessibleMenuOptions,
  }
}
